// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ma-0";
export var fileList = "_ma-2";
export var removeFileButton = "_ma-1";